<template>
    <!-- About section start -->
	<section id="about-section" class="px-12 lg:px-32 py-16 border-t border-stone-500 relative">
        <!-- Main text start -->
        <div class="flex flex-col">
        <div>
            <div class="flex flex-row">
                <div class="flex flex-col">
                    <h1 class="uppercase text-5xl mb-4 font-semibold ">
                        ABOUT US
                    </h1>
                    <p class="xl:w-1/2 text-stone-500 mb-8"> Welcome to Triple Palm Rehabilitation and Recovery Centre, located in Nakuru, Tuinuane phase 1, Kenya. We are dedicated to providing compassionate care and support for individuals on their path to recovery. Our experienced team offers personalized treatment plans that address the physical, emotional, and psychological aspects of healing. At Triple Palm, we create a safe and nurturing environment where clients can regain their strength and build a brighter future. Join us in taking the first step towards lasting recovery and empowerment. </p>
                </div>
                
            </div>
		
		<!-- Main text end -->

       
        <!-- "More" link end -->

        <!-- Circle start -->
        <div class="bg-neutral-200 h-44 w-44 md:h-52 md:w-52 rounded-full absolute top-0 -left-20 mt-16 -z-20"></div>
        <!-- Circle end -->

        </div>
        <div class="flex flex-col md:flex-row md:gap-8">
            <!-- Wedding service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/shared-vision.png" alt="mission" class="w-[200px] h-[200px] -z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold">
                        Our mission
                    </h1>
                    <p class=" text-stone-500 mt-[20px]">
                        To empower individuals to get their highest level of recovery and functioning in life through excellent rehabilitation.
                    </p>
                </div>
            </div>

            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/vision.png" alt="vision" class="w-[200px] h-[200px] -z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold">
                        Our vision
                    </h1>
                    <p class=" text-stone-500 mt-[20px]">
                        To help individuals, family and communities achieve freedom from addiction and be fully functional in the lives.
                    </p>
                </div>
            </div>

            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/values.png" alt="mission" class="w-[200px] h-[200px] -z-50 hidden md:block">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="uppercase text-2xl font-semibold">
                        Core values
                    </h1>
                    <p class=" text-stone-500">
                        Our core values focus on respect, holistic care, teamwork, reverence, and collaboration. We treat individuals with kindness and dignity, support informed recovery decisions, and involve families in the process. Emphasizing the uniqueness of each person, we work together as professionals toward shared goals, guided by the belief that "the fear of God is the beginning of wisdom." We also seek partnerships to enhance the well-being of those we serve.
                    </p>
                </div>
            </div>
            
            
            <!-- Wedding service end -->
        </div>
        </div>
	</section>
	<!-- About section end -->
</template>

<script>
export default {

}
</script>

<style>

</style>